import { pick, has } from 'lodash-es'
import { makeRequest } from '../base/axios.ts'

// returns a new object containing only the keys we would like to persist to the server
function _extractServerAttributes(timespan) {
  const attributes = pick(timespan, ['title', 'description', 'start_date', 'end_date'])
  // remove any photos with id 0, this signifies an empty image
  if (has(attributes, 'photo_ids')) {
    if (attributes.photo_ids[0] === 0) {
      throw new Error("Photo has id of 0. Don't send that to api or it'll 404")
    }
  }
  return attributes
}

export default {
  // returns a promise if no pending requests
  createTimespan: function (timespan) {
    const timelineId = timespan.timeline_id
    const data = {
      timespan: _extractServerAttributes(timespan),
    }
    return makeRequest({
      url: `/api/v1/timelines/${timelineId}/timespans`,
      method: 'post',
      data,
      requestId: 'post-timespans',
    })
  },

  updateTimespan: function (timespan) {
    const timelineId = timespan.timeline_id
    const timespanId = timespan.id
    const data = {
      timespan: _extractServerAttributes(timespan),
    }
    return makeRequest({
      url: `/api/v1/timelines/${timelineId}/timespans/${timespanId}`,
      method: 'put',
      data,
      requestId: `put-timespan-${timespanId}`,
    })
  },

  deleteTimespan: function (timespan) {
    const timelineId = timespan.timeline_id
    const timespanId = timespan.id
    return makeRequest({
      url: `/api/v1/timelines/${timelineId}/timespans/${timespanId}`,
      method: 'delete',
      requestId: `del-timespan-${timespanId}`,
    })
  },
}
